import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { savedSearchTabEntryPoint } from '@atlassian/jira-assets-data-manager-object-class-view/src/ui/tabs/saved-search/entrypoint.tsx';
import { tagsTabEntryPoint } from '@atlassian/jira-assets-data-manager-object-class-view/src/ui/tabs/tags/entrypoint.tsx';
import { objectsTabEntryPoint } from '@atlassian/jira-assets-data-manager-object-class-view/src/ui/tabs/objects/entrypoint.tsx';

export const assetsDataManagerObjectClassViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-assets-data-manager-object-class-view", jiraSpaEntry: "async-assets-data-manager-object-class-view" */ './src/index.tsx'
			),
	),
	getPreloadProps: ({ context: { query } }: EntryPointRouteParams) => {
		const { tab } = query;
		if (tab === 'saved-search') {
			return {
				entryPoints: {
					savedSearchTabEntryPoint: {
						entryPoint: savedSearchTabEntryPoint,
					},
				},
			};
		}
		if (tab === 'tags') {
			return {
				entryPoints: {
					tagsTabEntryPoint: {
						entryPoint: tagsTabEntryPoint,
					},
				},
			};
		}
		// default to objects tab
		return {
			entryPoints: {
				objectsTabEntryPoint: {
					entryPoint: objectsTabEntryPoint,
				},
			},
		};
	},
});
